import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Clean hash, then navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-background"
      data-testid="auth-callback-loading"
    >
      <Loader2 className="w-10 h-10 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Signing you in…</p>
    </div>
  );
}
